import type { ErrorReportController } from '@app/services/ErrorReportController'

import { createThunk } from '@app/store/thunk'

export function getErrorReportController() {
  return createThunk((_dispatch, _getState, context) => context.lookupEnsure<ErrorReportController>(ErrorReportControllerSymbol))
}
export function setErrorReportController(value: ErrorReportController) {
  return createThunk((_dispatch, _getState, context) => context.getRootContext().set(ErrorReportControllerSymbol, value))
}

const ErrorReportControllerSymbol = Symbol('ErrorReportController')
